import React, { useEffect, useState } from "react";
import backarrow from "../../Assets/svg/backarrow.svg";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { apiCall } from "../../services/api-service.js";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import { useNavigate, useLocation } from "react-router-dom";
import reddelete from "../../Assets/svg/reddelete.svg";

const ComponentAdd = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [selectedRegionOptions, setSelectedRegionOptions] = useState([]);
  const [selectedLocationOptions, setSelectedLocationOptions] = useState([]);
  const [selectedProjectOptions, setSelectedProjectOptions] = useState([]);
  const [selectedComponentOptions, setSelectedComponentOptions] = useState([]);
  const [priority, setPriority] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [removedEscalationLines, setRemovedEscalationLines] = useState([]);
  const [escalationName, setEscalationName] = useState("");

  const [escalationList, setEscalationList] = useState([
    /* 
            {
                id:0,
                project:[{value:'',label:'Select'}],
                priority:'high', 
                levels:[
                    {
                        id:0,
                        role:{value:'',label:'Select'},
                        designation:{value:'',label:'Select'},
                        user:{value:'',label:'Select'},
                        estimation:''
                    },
                ] 
            } */
  ]);
  const [groupedError, setGroupedError] = useState({});
  const [validations, setValidations] = useState({
    name: "",
    regions: "",
    locations: "",
    projects: "",
    components: "",
    priority: "",
    escalation_lines: "",
  });
  useEffect(() => {
    if (id != null && id != undefined) {
      escalationEdit(id);
    }
  }, []);

  const addEscalationLine = () => {
    const tempList = [...escalationList];

    tempList.push({
      id: "",
      user: { value: "", label: "Select" },
      open: "",
      inprogress: "",
      hold: "",
    });
    setEscalationList(tempList);
  };

  const handleUserDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...escalationList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].user = selectedOptions;
      setEscalationList(tempList);
    }
  };

  const resetValidationState = () => ({
    name: "",
    regions: "",
    locations: "",
    projects: "",
    components: "",
    priority: "",
    escalation_lines: "",
  });

  const buildGroupedError = (errorObj = {}) => {
    const groupedErrorTemp = {};
    Object.entries(errorObj).forEach(([key, value]) => {
      const match = key.match(/^escalation_lines\.(\d+)\.(.+)$/);
      if (match) {
        const index = match[1];
        const field = match[2];
        if (!groupedErrorTemp[index]) {
          groupedErrorTemp[index] = {};
        }
        groupedErrorTemp[index][field] = value;
      }
    });
    return groupedErrorTemp;
  };

  const applyApiErrors = (errorData = {}) => {
    const validationTemp = resetValidationState();
    Object.entries(errorData.error ?? {}).forEach(([key, value]) => {
      validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
    });
    setGroupedError(buildGroupedError(errorData.error ?? {}));
    setValidations(validationTemp);
  };

  const escalationSubmit = async () => {
    const tempEscalation = [];
    let hasValidationError = false;
    const groupedErrorTemp = {};

    escalationList.forEach((item, index) => {
      const openVal = item.open ?? "";
      const inprogressVal = item.inprogress ?? "";
      const holdVal = item.hold ?? "";

      const timeRegex = /^([0-9]+):[0-5][0-9]$/;

      if (!openVal) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].open = ["Open estimation field is required"];
        hasValidationError = true;
      } else if (!timeRegex.test(openVal)) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].open = ["Open estimation must be in HH:MM format"];
        hasValidationError = true;
      }

      if (!inprogressVal) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].inprogress = ["InProgress estimation field is required"];
        hasValidationError = true;
      } else if (!timeRegex.test(inprogressVal)) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].inprogress = ["InProgress estimation must be in HH:MM format"];
        hasValidationError = true;
      }

      if (!holdVal) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].hold = ["Hold estimation field is required"];
        hasValidationError = true;
      } else if (!timeRegex.test(holdVal)) {
        if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
        groupedErrorTemp[index].hold = ["Hold estimation must be in HH:MM format"];
        hasValidationError = true;
      }

      tempEscalation.push({
        id: item.id ?? "",
        emp_id: item.user != null ? item.user.value : "",
        open: openVal,
        inprogress: inprogressVal,
        hold: holdVal,
      });
    });

    if (hasValidationError) {
      setGroupedError(groupedErrorTemp);
      setValidations(resetValidationState());
      return;
    }

    setValidations(resetValidationState());
    const requestBody = {
      name: escalationName,
      regions: selectedRegionOptions
        .filter((item) => item.value !== "")
        .map((item) => item.value),
      locations: selectedLocationOptions
        .filter((item) => item.value !== "")
        .map((item) => item.value),
      projects: selectedProjectOptions
        .filter((item) => item.value !== "")
        .map((item) => item.value),
      components: selectedComponentOptions
        .filter((item) => item.value !== "")
        .map((item) => item.value),
      priority,
      escalation_lines: tempEscalation,
      removed_lines: removedEscalationLines,
    };

    const isNew = id === null || id === undefined || id === -1;
    const response = await apiCall(
      isNew ? "post" : "put",
      isNew ? "escalation" : `escalation/${id}`,
      requestBody
    );

    if (response?.status === 200 && response.data?.success === true) {
      navigate(-1);
      return;
    }

    if (response?.data?.error) {
      applyApiErrors(response.data);
    }
  };

  const escalationEdit = async (id) => {
    const response = await apiCall("get", `escalation/${id}`);
    if (response?.status !== 200 || response.data?.success !== true) {
      return;
    }

    const escalation = response.data.escalation;
    setEscalationName(escalation.name);
    setSelectedRegionOptions(escalation.regions ?? []);
    setSelectedLocationOptions(escalation.locations ?? []);
    setSelectedProjectOptions(escalation.projects ?? []);
    setSelectedComponentOptions(escalation.components ?? []);
    setPriority(escalation.priority ?? "");
    setEscalationList(
      (escalation.lines ?? []).map((item) => ({
        id: item.id,
        user: { value: item.emp_id ?? "", label: item.emp ?? "Select" },
        open: item.open,
        inprogress: item.inprogress,
        hold: item.hold,
      }))
    );
  };

  const getErrorMsg = (index, field) => {
    if (field === "emp_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].emp_id != null) {
          return (
            groupedError[index].emp_id[0]?.replace(
              `escalation_lines.${index}.emp_id`,
              "user"
            ) ?? ""
          );
        }
      }
    }
    if (field === "open") {
      if (groupedError[index] != null) {
        if (groupedError[index].open != null) {
          return (
            groupedError[index].open[0]?.replace(
              `escalation_lines.${index}.open`,
              "open"
            ) ?? ""
          );
        }
      }
    }
    if (field === "allocated") {
      if (groupedError[index] != null) {
        if (groupedError[index].allocated != null) {
          return (
            groupedError[index].allocated[0]?.replace(
              `escalation_lines.${index}.allocated`,
              "allocated"
            ) ?? ""
          );
        }
      }
    }
    if (field === "inprogress") {
      if (groupedError[index] != null) {
        if (groupedError[index].inprogress != null) {
          return (
            groupedError[index].inprogress[0]?.replace(
              `escalation_lines.${index}.inprogress`,
              "inprogress"
            ) ?? ""
          );
        }
      }
    }
    if (field === "hold") {
      if (groupedError[index] != null) {
        if (groupedError[index].hold != null) {
          return (
            groupedError[index].hold[0]?.replace(
              `escalation_lines.${index}.hold`,
              "hold"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  const handleRegionDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedRegionOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedRegionOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedRegionOptions(updatedOptions);
    } else {
      setSelectedRegionOptions([...selectedRegionOptions, selectedOptions]);
    }
  };

  const handleLocationDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedLocationOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedLocationOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedLocationOptions(updatedOptions);
    } else {
      setSelectedLocationOptions([...selectedLocationOptions, selectedOptions]);
    }
  };

  const handleProjectDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedProjectOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedProjectOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedProjectOptions(updatedOptions);
    } else {
      setSelectedProjectOptions([...selectedProjectOptions, selectedOptions]);
    }
  };

  const handleComponentDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedComponentOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedComponentOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedComponentOptions(updatedOptions);
    } else {
      setSelectedComponentOptions([
        ...selectedComponentOptions,
        selectedOptions,
      ]);
    }
  };
  const removeFilter = (index) => {
    /*  setFilters(filters.filter((filter) => filter.id !== id)); */ // Remove the row by ID
    if (escalationList[index].id != null && escalationList[index].id !== "") {
      setRemovedEscalationLines([
        ...removedEscalationLines,
        escalationList[index].id,
      ]);
    }
    setEscalationList(escalationList.filter((_, i) => i !== index));
  };
  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div style={{ fontFamily: "Satoshi" }}>
              <div
                className="px-3 py-3 d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#F3F6F9" }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                >
                  <div>
                    <img
                      onClick={() => {
                        navigate(-1);
                      }}
                      style={{ cursor: "pointer" }}
                      src={backarrow}
                      alt=""
                    />
                  </div>

                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#212129",
                    }}
                  >
                    New Escalation
                  </div>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                >
                  <button
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      backgroundColor: "#FFFFFF",
                      color: "#212129",
                      border: "none",
                      borderRadius: "100px",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                    className="px-4 py-2"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      escalationSubmit();
                    }}
                    style={{
                      backgroundColor: "#6929E2",
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: "100px",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                    className="px-4 py-2"
                  >
                    Save
                  </button>
                </div>
              </div>

              <div
                style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}
                className="px-3 py-3 mx-3"
              >
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                      color: "#212129",
                    }}
                  >
                    Add Escalation
                  </div>

                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#8790A1",
                    }}
                  >
                    Enter below details to create new escalation
                  </div>
                </div>
                <Row>
                  <Col sm={12} md={6} lg={6} xl={6} className="mt-2">
                    <div
                      className="pb-2"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#212129",
                      }}
                    >
                      Escalation name<span style={{ color: "red" }}> *</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        value={escalationName}
                        onChange={(event) => {
                          setEscalationName(event.target.value);
                        }}
                        placeholder="Enter here"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "0.8px solid #E5E5E5",
                          backgroundColor: "#FFFFFF",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#21272C",
                        }}
                        className="px-3 py-2"
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.name}
                      </span>
                    </div>
                  </Col>
                  <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                    <div
                      className="pb-2"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#212129",
                      }}
                    >
                      Region<span style={{ color: "red" }}> *</span>
                    </div>
                    <div>
                      <MultiSelectDropDown
                        onDropdownChange={handleRegionDropdownChange}
                        apiUrl={adminUrl + `region/autocomplete`}
                        placeholder={"Region"}
                        selectedOption={selectedRegionOptions}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.regions}
                      </span>
                    </div>
                  </Col>
                    <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                    <div
                      className="pb-2"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#212129",
                      }}
                    >
                      Location<span style={{ color: "red" }}> *</span>
                    </div>
                    <div>
                      <MultiSelectDropDown
                        onDropdownChange={handleLocationDropdownChange}
                        apiUrl={adminUrl + `get_location`}
                        placeholder={"Location"}
                        selectedOption={selectedLocationOptions}
                        params={
                          selectedRegionOptions.filter((r) => r.value !== "").length > 0
                            ? {
                                region_id: selectedRegionOptions
                                  .filter((r) => r.value !== "")
                                  .map((r) => r.value)
                                  .join(","),
                              }
                            : {}
                        }
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.locations}
                      </span>
                    </div>
                  </Col>

                  <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                    <div
                      className="pb-2"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#212129",
                      }}
                    >
                      Project<span style={{ color: "red" }}> *</span>
                    </div>
                    <div>
                      <MultiSelectDropDown
                        onDropdownChange={handleProjectDropdownChange}
                        apiUrl={apiUrl + `get_project`}
                        placeholder={"Project"}
                        selectedOption={selectedProjectOptions}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.projects}
                      </span>
                    </div>
                  </Col>

                  <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                    <div
                      className="pb-2"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#212129",
                      }}
                    >
                      Component<span style={{ color: "red" }}> *</span>
                    </div>
                    <div>
                      <MultiSelectDropDown
                        onDropdownChange={handleComponentDropdownChange}
                        apiUrl={apiUrl + `get_component`}
                        placeholder={"Component"}
                        selectedOption={selectedComponentOptions}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.components}
                      </span>
                    </div>
                  </Col>
                  <Col
                    sm={12}
                    md={6}
                    lg={3}
                    xl={3}
                    style={{ marginTop: "16px" }}
                  >
                    <h1
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "500",
                        fontSize: "13px",
                        lineHeight: "17.55px",
                        color: "#212129",
                      }}
                    >
                      Priority
                    </h1>
                    <select
                      className="w-100"
                      value={priority}
                      onChange={(e) => setPriority(e.target.value)}
                      style={{
                        /*  width: "264.75px", */
                        height: "40px",
                        fontFamily: "Satoshi",
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18.9px",
                        color: "#8790A1",
                        border: "0.7px solid #E5E5E5",
                        padding: "0 16px",
                        gap: "77px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "10px",
                      }}
                    >
                      <option value="">Select</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.priority}
                    </span>
                  </Col>
                </Row>
              </div>

              <div
                style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}
                className="px-3 py-3 mx-3 my-3"
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                    color: "#212129",
                  }}
                  className="mb-3"
                >
                  Escalations
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.escalation_lines}
                </span>
                {escalationList.map((filter, fIndex) => (
                  <div
                    key={"line" + filter.id}
                    className="my-2 px-3 py-2"
                    style={{ backgroundColor: "#FFFFFF", borderRadius: "16px" }}
                  >
                    <div className="d-flex align-items-center justify-content-start">
                      <Row style={{ width: "100%" }}>
                        <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "17.55px",
                              color: "#212129",
                              marginBottom: "8px",
                            }}
                          >
                            User
                          </p>
                          <SearchWithAPI
                            searchId={fIndex}
                            onChangeIndex={{ parentIndex: fIndex }}
                            onDropdownChange={handleUserDropdownChange}
                            apiUrl={apiUrl + `get_employee`}
                            placeholder={"User"}
                            selectedValue={
                              filter.user != null ? filter.user.label : ""
                            }
                            selectedOption={filter.user}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {getErrorMsg(fIndex, "emp_id")}
                          </span>
                        </Col>

                        <Col sm={12} md={4} lg={3} xl={3} className="mt-2">
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "17.55px",
                              color: "#212129",
                              marginBottom: "8px",
                            }}
                          >
                            Open
                          </p>
                          <input
                            className="w-100"
                            id="est"
                            type="text"
                            value={filter.open}
                            onChange={(event) => {
                              const inputText = event.target.value;
                              if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                if (lastKey === "Backspace") {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].open = inputText;
                                    setEscalationList(tempList);
                                  }
                                } else {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].open =
                                      inputText.length === 2
                                        ? inputText + ":"
                                        : inputText;
                                    setEscalationList(tempList);
                                  }
                                }
                              }
                            }}
                            onKeyDown={(event) => {
                              setLastKey(event.key);
                            }}
                            style={{
                              height: "44px",
                              borderRadius: "10px",
                              gap: "77px",
                              padding: "16px",
                              border: "0.7px solid #E5E5E5",
                              fontFamily: "Satoshi",
                              fontWeight: "500px",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                              backgroundColor: "#FFFFFF",
                            }}
                            placeholder="hh:mm"
                            maxLength={5}
                          />
                          {/* <span style={{fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.est}</span> */}
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {getErrorMsg(fIndex, "open")}
                          </span>
                        </Col>

                        {/* <Col sm={12} md={4} lg={3} xl={2} className="mt-2">
                                                            <p style={{fontFamily: 'Satoshi',fontSize: '13px',fontWeight: '500',lineHeight: '17.55px',color:'#212129',marginBottom:'8px'}}>Allocated</p>
                                                            <input className='w-100' id="est" type="text" value={filter.allocated}  onChange={(event) => {
                            
                              const inputText = event.target.value;
                              if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {                               
                                if(lastKey === "Backspace"){     
                                  const tempList =[...escalationList];
                                            if (tempList[fIndex] !== undefined ) {
                                                tempList[fIndex].allocated=inputText;
                                                setEscalationList(tempList);  
                                            } 
                                }else{
                                    const tempList =[...escalationList];
                                    if (tempList[fIndex] !== undefined ) {
                                        tempList[fIndex].allocated=inputText.length===2?inputText+':':inputText;
                                        setEscalationList(tempList);  
                                    }
                                }    
                              }   
                            }} onKeyDown={(event) => {
                              setLastKey(event.key);  
                            }} style={{height:'44px',borderRadius:'10px',gap:'77px',padding:'16px',border:'0.7px solid #E5E5E5',fontFamily:'Satoshi',fontWeight:'500px',fontSize:'14px',lineHeight:'18.9px',color:'#21272C',backgroundColor:'#FFFFFF'}} placeholder="hh:mm"  maxLength={5} />
                                                           
                                                   <span style={{fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{getErrorMsg(fIndex,'allocated')}</span>
                                                            </Col> */}

                        <Col sm={12} md={4} lg={3} xl={3} className="mt-2">
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "17.55px",
                              color: "#212129",
                              marginBottom: "8px",
                            }}
                          >
                            InProgress
                          </p>
                          <input
                            className="w-100"
                            id="est"
                            type="text"
                            value={filter.inprogress}
                            onChange={(event) => {
                              const inputText = event.target.value;
                              if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                if (lastKey === "Backspace") {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].inprogress = inputText;
                                    setEscalationList(tempList);
                                  }
                                } else {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].inprogress =
                                      inputText.length === 2
                                        ? inputText + ":"
                                        : inputText;
                                    setEscalationList(tempList);
                                  }
                                }
                              }
                            }}
                            onKeyDown={(event) => {
                              setLastKey(event.key);
                            }}
                            style={{
                              height: "44px",
                              borderRadius: "10px",
                              gap: "77px",
                              padding: "16px",
                              border: "0.7px solid #E5E5E5",
                              fontFamily: "Satoshi",
                              fontWeight: "500px",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                              backgroundColor: "#FFFFFF",
                            }}
                            placeholder="hh:mm"
                            maxLength={5}
                          />
                          {/* <span style={{fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.est}</span> */}
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {getErrorMsg(fIndex, "inprogress")}
                          </span>
                        </Col>

                        <Col sm={12} md={4} lg={3} xl={3} className="mt-2">
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "17.55px",
                              color: "#212129",
                              marginBottom: "8px",
                            }}
                          >
                            Hold
                          </p>
                          <input
                            className="w-100"
                            id="est"
                            type="text"
                            value={filter.hold}
                            onChange={(event) => {
                              const inputText = event.target.value;
                              if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                if (lastKey === "Backspace") {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].hold = inputText;
                                    setEscalationList(tempList);
                                  }
                                } else {
                                  const tempList = [...escalationList];
                                  if (tempList[fIndex] !== undefined) {
                                    tempList[fIndex].hold =
                                      inputText.length === 2
                                        ? inputText + ":"
                                        : inputText;
                                    setEscalationList(tempList);
                                  }
                                }
                              }
                            }}
                            onKeyDown={(event) => {
                              setLastKey(event.key);
                            }}
                            style={{
                              height: "44px",
                              borderRadius: "10px",
                              gap: "77px",
                              padding: "16px",
                              border: "0.7px solid #E5E5E5",
                              fontFamily: "Satoshi",
                              fontWeight: "500px",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                              backgroundColor: "#FFFFFF",
                            }}
                            placeholder="hh:mm"
                            maxLength={5}
                          />
                          {/* <span style={{fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.est}</span> */}
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {getErrorMsg(fIndex, "hold")}
                          </span>
                        </Col>
                      </Row>
                      <div
                        style={{
                          width: "70px",
                          display: "flex",
                          alignItems: "end",
                          justifyContent: "center",
                        }}
                        className="mt-2"
                      >
                        <div
                          onClick={() => {
                            removeFilter(fIndex);
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "44px",
                            height: "44px",
                            borderRadius: "100px",
                            background: "#F6F7F8",
                          }}
                        >
                          {" "}
                          <img
                            src={reddelete}
                            style={{ width: "40px", height: "40px" }}
                            alt="Delete"
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => {
                    addEscalationLine();
                  }}
                  style={{
                    width: "153px",
                    height: "33px",
                    padding: "8px 16px",
                    borderRadius: "12px",
                    background: "#F4ECFF",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Satoshi",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      fontWeight: "700",
                      color: "#6929E2",
                    }}
                  >
                    + Add Escalation
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ComponentAdd;
